<script setup lang="ts">
import Avatar from "primevue/avatar";
import User from "@/Models/User";

const props = defineProps<{user?: any; initials?: string; image?: string}>();
const $user = props.user ? new User(props.user) : null;
</script>
<template>
    <Avatar
        :class="[
            `bg-${$user?.profile?.color?.class ?? 'askr-green'}`,
            ['white', undefined].includes(user?.profile?.color?.class) ? 'text-black' : 'text-white',
        ]"
    >
        <img
            v-if="!!image || !!$user?.profile?.avatar?.url"
            :src="image ?? $user.profile.avatar?.url"
            :alt="$user?.name ?? initials ?? 'User avatar'"
            class="absolute left-0 top-0 h-full w-full object-contain"
        />
        <span v-else-if="initials || $user?.initials">{{ initials || $user?.initials }}</span>
    </Avatar>
</template>
<style scoped></style>
